import { Component, OnDestroy, OnInit, inject, viewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Position } from 'geojson';
import * as _ from 'lodash';
import { isEqual as _isEqual } from 'lodash';
import { finalize, takeUntil, tap } from 'rxjs/operators';

import {
  CreateSmartSmsRequestCommand,
  EnumSmartAdsGender,
  GetDeviceModelsByBrandDto,
  SmartRequestTypes,
  SmartSmsClubOperationType,
  SmartSmsRequestJoberState,
  SmartSmsRequestResidenceState,
  SmartSmsRequestTravellerState,
  SmsAggregator,
} from 'src/app/core/api/models';
import { SmartSmsRequestPolygonWithTitleModel } from 'src/app/core/api/models/smart-sms-request-polygon-with-title-model';
import {
  CustomPlaceService,
  SmartSmsRequestsService,
  ZonesService,
} from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { ConsoleService } from 'src/app/core/services/console.service';
import {
  DialogService,
  DialogStatus,
} from 'src/app/core/services/dialog.service';
import { AppDomService } from 'src/app/core/services/dom.service';
import { DynamicTabService } from 'src/app/core/services/dynamic-tab.service';
import { TransferDataService } from 'src/app/core/services/transfer-data.service';
import { PeriodicDateTimeConfig } from 'src/app/shared/components/periodic-date-time-picker/periodic-date-time-picker.component';
import { PublicPlaceSelectSearchComponent } from 'src/app/shared/components/select-search/public-places-select-search.component';
import { ZonesSelectSearchComponent } from 'src/app/shared/components/select-search/zones-select-search.component';
import { SmartSendMapControlComponent } from 'src/app/shared/components/smart-send-map-control/smart-send-map-control.component';
import { environment } from 'src/environments/environment';
import { BaseFormPageComponent } from '../../shared/base/components/base-form-page.component';
import { AppStateService } from './../../../core/services/app-state.service';
import { TabsDynamicComponent } from './../../../layout/components/tabs-dynamic/tabs-dynamic.component';
import { CellsListComponent } from './cells-list/cells-list.component';
import { FilterItem } from './filter-row/filter-row.component';
import { SendSmartSmsAdvanceSearchlComponent } from './send-smart-sms-advance-search/send-smart-sms-advance-search.component';

@Component({
  selector: 'app-create-smart-sms-request',
  templateUrl: './send-smart-sms-create-request.component.html',
  styleUrls: ['./send-smart-sms-create-request.scss'],
  standalone: false,
})
export class SendSmartSmsCreateRequestComponent
  extends BaseFormPageComponent
  implements OnInit, OnDestroy
{
  appStateService = inject(AppStateService);
  //#region properties

  formId: string = 'SendSmartSmsCreateRequestForm';
  tabName: string = 'sendSmartSMS';
  periodicDateTimeConfig: PeriodicDateTimeConfig;
  stateId: number = null;
  cityId: number = -1;
  startTime: string;
  endTime: string;
  selectedPlacePolygon: string;
  publicPlaceId: number | null = null;
  title: string = '';
  grayListExpireHour: number;
  numberPrefix: string;
  selectedDeviceType: any[] = [];
  selectedDeviceBrands: any;
  // selectedDeviceModelIds: any[] = [];
  selectedDeviceModels: GetDeviceModelsByBrandDto[] = [];
  gender: EnumSmartAdsGender | null = null;
  joberState: SmartSmsRequestJoberState | null = null;
  travellerState: SmartSmsRequestTravellerState | null = null;
  travellerProvinces: any[] = [];
  residenceState: SmartSmsRequestResidenceState | null = null;
  ageRange: number[] = [];
  smartRequestType: SmartRequestTypes;
  campaignId: number;
  clubId: number;
  operationType: SmartSmsClubOperationType;
  polygon: any = null;
  removePolygon: any = null;
  selectedOperator: SmsAggregator;
  operators: Array<SmsAggregator> = [];
  cellList: any;
  provinceId;
  cities: Array<number> = [];
  provinces: Array<number> = [];
  targetAirportId: number;
  polygonSample =
    '[[51.632501410374715,32.685432324977654],[51.71922427017287,32.685432324977654],[51.66042911098796,32.64913607398054],[51.632501410374715,32.685432324977654]]';
  cellListSample = '[541214762,145833]';
  isShowBrandModel: boolean;
  get SmartSendGender() {
    return EnumSmartAdsGender;
  }
  get SmartRequestType() {
    return SmartRequestTypes;
  }
  isVisibleHelpPage: boolean = false;
  isShowMap: boolean = true;
  filteredValue: string;

  isPeriodicSmartSend: boolean = false;
  isShowGrayListExpireHour: boolean = false;
  isShowCampaigns: boolean = false;
  isCheckBoxChecked: boolean = false;
  isShowClub: boolean = false;
  isShowCities: boolean = false;
  isShowProvince: boolean = false;
  isShowProvinces: boolean = false;
  isShowCellList: boolean = false;
  isShowTargetAirport: boolean = false;
  artisticCulture: any;
  polygonsTitle: any[] = [];
  selectedDeviceBrandName: string = '';
  //the filter items
  public filterItems: FilterItem[] = [
    {
      Title: 'pages.createSmartSmsRequest.filters.gender',
      Key: 'Gender',
      Checked: false,
      IsVisible: true,
    },
    {
      Title: 'pages.createSmartSmsRequest.filters.age',
      Key: 'Age',
      Checked: false,
      IsVisible: true,
    },
    {
      Title: 'pages.createSmartSmsRequest.filters.mobilePrefix',
      Key: 'MobilePrefix',
      Checked: false,
      IsVisible: true,
    },
    {
      Title: 'pages.createSmartSmsRequest.filters.deviceType',
      Key: 'DeviceType',
      Checked: false,
      IsVisible: true,
    },
    {
      Title: 'pages.createSmartSmsRequest.filters.deviceBrand',
      Key: 'DeviceBrand',
      Checked: false,
      IsVisible: true,
    },

    {
      Title: 'pages.createSmartSmsRequest.filters.eghamatgah',
      Key: 'Eghamatgah',
      Checked: false,
      IsVisible: true,
    },
    {
      Title: 'pages.createSmartSmsRequest.filters.gardeshgari',
      Key: 'Vacaton',
      Checked: false,
      IsVisible: true,
    },
    // {
    //   Title: 'pages.createSmartSmsRequest.filters.bankProfile',
    //   Key: 'BankingProfile',
    //   Checked: false,
    //   IsVisible: true,
    // },
    {
      Title: 'pages.createSmartSmsRequest.filters.jobs',
      Key: 'Jobs',
      Checked: false,
      IsVisible: true,
    },
    // {
    //   Title: 'pages.createSmartSmsRequest.filters.favorites',
    //   Key: 'Favorites',
    //   Checked: false,
    //   IsVisible: true,
    // },
    // {
    //   Title: 'pages.createSmartSmsRequest.filters.ertebatat',
    //   Key: 'ComminucationProfile',
    //   Checked: false,
    //   IsVisible: true,
    // },
    // {
    //   Title: 'pages.createSmartSmsRequest.filters.artisticCulture',
    //   Key: 'ArtisticCulture',
    //   Checked: false,
    //   IsVisible: true,
    // },
  ];

  requiredFields: string[] = [];

  readonly citySelectSearch =
    viewChild<ZonesSelectSearchComponent>('citySelectSearch');
  readonly publicPlaceSelect =
    viewChild<PublicPlaceSelectSearchComponent>('publicPlaceSelect');
  readonly Map = viewChild<SmartSendMapControlComponent>('Map');
  showSidePanel: boolean = true;

  //#endregion

  public constructor(
    public dynamicTabService: DynamicTabService,
    public customPlaceService: CustomPlaceService,
    public dialogService: DialogService,
    public translate: TranslateService,
    protected currentService: SmartSmsRequestsService,
    public zoneService: ZonesService,
    private tabsDynamicComponent: TabsDynamicComponent
  ) {
    super();
    this.baseCreateGetApiForSend(
      this.currentService,
      'smartSmsRequestsCreateGet'
    );
  }

  ngOnInit(): void {
    try {
      TransferDataService.selectedListPersonal = [];
      TransferDataService.selectedListPublic = [];
      super.ngOnInit();
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.smartSms);
    }
  }

  isExitInSelectedFilters(filterKey): boolean {
    let isExist: boolean = false;
    if (this.filterItems.find((item) => item.Key == filterKey)) isExist = true;
    return;
  }

  initModel(): void {
    super.initModel();
    this.smartRequestType = SmartRequestTypes.Simple;
  }

  closeThisTab() {
    try {
      const TimeOut = setTimeout(() => {
        this.tabsDynamicComponent.manualCloseTab('sendSmartSMS');
        clearTimeout(TimeOut);
      }, 50);
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.smartSms);
    }
  }

  initForm(): void {
    this.pageVocabs = 'pages.createSmartSmsRequest.';
    this.title = '';
    //throw new Error('Method not implemented.');
    this.form = new FormGroup({
      publicPlaceId: new FormControl(''),
      stateControl: new FormControl(''),
      cityControl: new FormControl(''),
      startDatetime: new FormControl('', Validators.required),
      startTime: new FormControl('', Validators.required),
      endDatetime: new FormControl('', Validators.required),
      endTime: new FormControl('', Validators.required),
      title: new FormControl('', [
        Validators.required,
        Validators.maxLength(80),
      ]),
      grayListExpireHour: new FormControl(''),
      cellList: new FormControl(''),
      gender: new FormControl(),
      ageRange: new FormControl(),
      startRangeControlName: new FormControl(),
      endRangeControlName: new FormControl(),
      mobilePrefix: new FormControl(
        '',
        Validators.pattern('^(?!0)9[0-9]{1,6}')
      ),
      deviceType: new FormControl(),
      deviceBrand: new FormControl(),
      deviceModel: new FormControl(),
      residenceState: new FormControl(),
      joberState: new FormControl(),
      travellerState: new FormControl(),
      travellerProvinces: new FormControl(),
      isPeriodic: new FormControl(),
      smartRequestType: new FormControl('', Validators.required),
      campaignId: new FormControl(''),
      clubId: new FormControl(''),
      operationType: new FormControl(''),
      polygon: new FormControl(''),

      cities: new FormControl(''),
      province: new FormControl(''),
      provinces: new FormControl(''),
      targetAirportId: new FormControl(''),
      artisticCulture: new FormControl(''),
    });
    this.form.get('isPeriodic').valueChanges.subscribe((val) => {
      if (val != true) {
        this.form.controls['startDatetime'].setValidators([
          Validators.required,
        ]);
        this.form.controls['endDatetime'].setValidators([Validators.required]);
        this.form.controls['startTime'].setValidators([Validators.required]);
        this.form.controls['endTime'].setValidators([Validators.required]);
      } else {
        this.form.controls['startDatetime'].clearValidators();
        this.form.controls['endDatetime'].clearValidators();
        this.form.controls['startTime'].clearValidators();
        this.form.controls['endTime'].clearValidators();
      }
      this.form.controls['startDatetime'].updateValueAndValidity();
      this.form.controls['endDatetime'].updateValueAndValidity();
      this.form.controls['startTime'].updateValueAndValidity();
      this.form.controls['endTime'].updateValueAndValidity();
    });
    try {
      this.periodicDateTimeConfig = {
        startDateLabel: 'common.startDate',
        startTimeLabel: 'common.startTime',
        endDateLabel: 'common.endDate',
        endTimeLabel: 'common.endTime',
        startDateFormControl: this.form?.get('startDatetime') as FormControl,
        startTimeFormControl: this.form?.get('startTime') as FormControl,
        endDateFormControl: this.form?.get('endDatetime') as FormControl,
        endTimeFormControl: this.form?.get('endTime') as FormControl,
        isConvertToIsoString: false,
        isEditMode: this.formPageConfig.isEditMode,
        minStartDateType: 'unlimited',
        maxStartDateType: 'today',
        maxEndDateType: 'today',
        responsiveClassName: '2xl:tw-w-1/2',
        maxStartTimeTheCurrentTimeIfDateIsToday: true,
        minStartTimeTheCurrentTimeIfDateIsToday: false,
        maxEndTimeTheCurrentTimeIfDateIsToday: true,
      };
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.smartSms);
    }
  }

  openPage(tabName: string) {
    try {
      this.dynamicTabService.setNewTab('');
      this.dynamicTabService.setNewTab(tabName);
      this.dynamicTabService.setActiveTab(tabName);
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.smartSms);
    }
  }

  public isDev() {
    return environment.production == false;
  }

  onCityChange($event) {
    if (this.citySelectSearch() == null) return;
    this.cityId = $event;
    this.zoneService
      .zonesGetZoneCoordinates({ ZoneId: this.cityId })
      .subscribe((result) => {
        try {
          let center = JSON.parse(result?.data) as mapboxgl.LngLatLike;
          var tmp = center[0];
          center[0] = center[1];
          center[1] = tmp;
          this.Map().SetCenter(center);
        } catch (error) {
          this.loggerService.logError(this.tagName, error, EventTypes.smartSms);
        }
      });
  }

  onPublicPlace($event) {
    try {
      this.publicPlaceId = $event;
      //handling delete event
      if ($event == null) {
        //most clear the polygon
        this.selectedPlacePolygon = '';
        this.Map().removePolygon();
        return;
      }
      for (
        let index = 0;
        index < this.publicPlaceSelect().items.length;
        index++
      ) {
        let item = this.publicPlaceSelect().items[index];
        if (item.id == $event) {
          this.selectedPlacePolygon = item.coordinates;
          let cord = JSON.parse(item.coordinates) as Position[][];
          this.cityId = item.cityId;
          this.stateId = item.provinceId;
          this.Map().AddDisplayPolygon(item.id, cord);
          break;
        }
      }
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.smartSms);
    }
  }

  //this method used to determine each filter row most show or not
  getMostShowFilterRow(key: string) {
    key = key.toLowerCase();
    for (var index = 0; index < this.filterItems.length; index++)
      if (this.filterItems[index].Key.toLowerCase() == key)
        return this.filterItems[index].Checked;
    return false;
  }

  selectedDeviceTypesChange($event: any[]) {
    this.selectedDeviceType = $event;
  }

  selectedTravellerProvincesChange($event: any[]) {
    this.travellerProvinces = $event;
  }

  selectedDeviceBrandChange($event: any[]) {
    this.selectedDeviceModels = [];
    // this.selectedDeviceBrands = [];
    // this.selectedDeviceBrandName = null;
    if ($event.length == 1) {
      this.isShowBrandModel = true;
      this.selectedDeviceBrands = [$event[0].id];
      this.selectedDeviceBrandName = $event[0].name;
    }
    if ($event.length > 1) {
      this.selectedDeviceBrands = $event.map((item) => item.id);
      this.isShowBrandModel = false;
    }
  }

  selectedDeviceModelChange($event: any[]) {
    this.selectedDeviceModels = $event;
  }

  selectedAgeRangeChange($event) {
    try {
      if ($event[0] && $event[1]) {
        this.ageRange = $event;
      }
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.smartSms);
    }
  }

  getFormJson() {
    return JSON.stringify(this.form.value);
  }

  wrongCellListDialog() {
    this.dialogService.openDialog({
      title: this.translate.instant('common.error'),
      message: this.translate.instant('messages.wrongCellList'),
      status: DialogStatus.error,
    });
    return;
  }

  onSubmit() {
    try {
      if (!this.isValidForm(this.form, this.tagName)) return;
      if (this.loading) return;
      if (!this.form.valid) {
        let errors = this.form.errors;
        if (errors)
          this.dialogService.openDialog({
            title: this.translate.instant('common.error'),
            message: errors,
            status: DialogStatus.error,
          });
        return;
      }
      if (this.operators.length <= 0) {
        this.dialogService.openDialog({
          title: this.translate.instant('common.error'),
          message: this.translate.instant(
            this.pageVocabs + 'errors.mustSelectOperator'
          ),
          status: DialogStatus.error,
        });
        return;
      }

      let _isPeriodic = this.form.controls['isPeriodic'].value == true;
      if ((!this.startTime || !this.endTime) && _isPeriodic == false) {
        this.dialogService.openDialog({
          title: this.translate.instant('common.error'),
          message: this.translate.instant(
            this.pageVocabs + 'errors.forceToEnterDatePeriod'
          ),
          status: DialogStatus.error,
        });
        return;
      }
      if (!this.title) {
        this.dialogService.openDialog({
          title: this.translate.instant('common.error'),
          message: this.translate.instant(
            this.pageVocabs + 'errors.titleIsRequired'
          ),
          status: DialogStatus.error,
        });
        return;
      }
      let _age = null;
      if (this.ageRange != null && this.getMostShowFilterRow('age'))
        _age = this.ageRange;
      let _deviceBrand = null;
      if (
        this.selectedDeviceBrands != null &&
        this.getMostShowFilterRow('DeviceBrand')
      )
        _deviceBrand = this.selectedDeviceBrands;
      let _deviceModel = null;

      if (
        this.selectedDeviceModels != null &&
        this.getMostShowFilterRow('DeviceBrand')
      )
        _deviceModel = this.selectedDeviceModels.map((item) => item.id);

      let _deviceTypes = null;
      if (
        this.selectedDeviceType != null &&
        this.getMostShowFilterRow('DeviceType')
      )
        _deviceTypes = this.selectedDeviceType;
      let _gender = null;
      if (this.gender != null && this.getMostShowFilterRow('gender'))
        _gender = [this.gender];
      let _numberPrefix = null;
      if (
        this.numberPrefix != null &&
        this.getMostShowFilterRow('mobilePrefix')
      )
        _numberPrefix = '98' + this.numberPrefix;
      let _residenceState = null;
      if (
        this.residenceState != null &&
        this.getMostShowFilterRow('Eghamatgah')
      )
        _residenceState = this.residenceState;
      let _joberState = null;
      if (this.joberState != null && this.getMostShowFilterRow('Eghamatgah'))
        _joberState = this.joberState;
      let _travellerState = null;
      let _travellerProvinces = null;
      if (this.travellerState != null && this.getMostShowFilterRow('Vacaton')) {
        _travellerState = this.travellerState;
        if (_travellerState == 1) {
          _travellerProvinces = this.travellerProvinces;
        }
      }
      if (this.smartRequestType == SmartRequestTypes.WelcomeWithCells) {
        try {
          let parsedCellList = JSON.parse(this.cellList);
          if (!Array.isArray(parsedCellList)) {
            this.wrongCellListDialog();
            return;
          }
        } catch (error) {
          this.wrongCellListDialog();
          return;
        }
      }
      let selectedPolygons;
      const Map = this.Map();
      if (Map) {
        selectedPolygons = this.ConvertPolygonsTo3plNumberArray(
          Map.getAllPolygons()
        );
        Map.getAllPolygonTitles().forEach((element) => {
          this.polygonsTitle.push(element);
        });
      }

      if (
        selectedPolygons?.length <= 0 &&
        this.polygon == null &&
        this.smartRequestType != SmartRequestTypes.WelcomeForCity &&
        this.smartRequestType != SmartRequestTypes.WelcomeForAirports &&
        this.smartRequestType != SmartRequestTypes.WelcomeForProvince
      ) {
        this.dialogService.openDialog({
          title: this.translate.instant('common.error'),
          message: this.translate.instant(
            this.pageVocabs + 'errors.mostSelectPolygon'
          ),
          status: DialogStatus.error,
        });
        return;
      }
      let drawedPolygons: Array<SmartSmsRequestPolygonWithTitleModel> = [];
      if (selectedPolygons?.length > 0) {
        selectedPolygons.forEach((element) => {
          let polygonObject = this.polygonsTitle.find((item) =>
            _isEqual(item.coordinates, element)
          );

          let polygon: SmartSmsRequestPolygonWithTitleModel = {
            polygons: element,
            title: polygonObject?.title,
          };
          drawedPolygons.push(polygon);
        });
      } else if (this.polygon) {
        let polygon: SmartSmsRequestPolygonWithTitleModel = {
          polygons: JSON.parse(this.polygon.toString()),
        };
        drawedPolygons.push(polygon);
      } else {
        drawedPolygons = [];
      }
      let requestBody: CreateSmartSmsRequestCommand = {
        polygons: drawedPolygons,
        operators: this.operators,
        endDatetime: _isPeriodic ? null : this.endTime,
        startDatetime: _isPeriodic ? null : this.startTime,
        title: this.title,
        age: _age,
        deviceBrand: _deviceBrand,
        deviceModel: _deviceBrand?.length == 1 ? _deviceModel : null,
        deviceType: _deviceTypes,
        gender: _gender,
        numberPrefix: _numberPrefix,
        travellerState: _travellerState,
        residenceProvinces: _travellerProvinces,
        joberState: _joberState,
        residenceState: _residenceState,
        isPeriodic: _isPeriodic,
        grayListExpireDate: this.grayListExpireHour,
        campaignId: this.campaignId,
        smartSmsClubId: this.clubId,
        operationType: this.operationType,
        smartRequestType: this.smartRequestType,
        cellList: this.cellList ? JSON.parse(this.cellList) : undefined,
        cities: this.cities,
        provinces: this.provinces,
        targetAirportId: this.targetAirportId,
      };

      this.model = { body: { requestBody } };
      this.loading = true;
      this.currentService
        .smartSmsRequestsCreatePost({ body: requestBody })
        .pipe(
          finalize(() => {
            this.loading = false;
          })
        )
        .subscribe((res) => {
          if (!res.isSucceed) {
            this.dialogService.openDialog({
              title: res?.message ?? this.translate.instant('common.error'),
              message: res?.validationErrors?.join('\n'),
              status: DialogStatus.error,
            });
          } else {
            this.dialogService.openDialog({
              title: this.translate.instant('common.succeed'),
              message:
                this.translate.instant('common.smartRequestId') + res?.data,
              status: DialogStatus.success,
            });
            this.refreshPage();
          }
        });
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.smartSms);
    }
  }

  onShowHelpPage() {
    this.isVisibleHelpPage = true;
  }

  onHideHelpPage() {
    this.isVisibleHelpPage = false;
  }

  refreshPage() {
    // this.tabsDynamicComponent.refreshTab(this.tabName);
    this.dynamicTabService.setNewTab('');
    this.dynamicTabService.setNewTab(this.tabName);
    this.dynamicTabService.setActiveTab(this.tabName);
  }

  reversePolygon() {
    if (!this.polygon) return;
    const polygonArray = JSON.parse(this.polygon);
    // Reversing each sub-array
    let reversedPolygon = _.map(polygonArray, (subArray) =>
      _.reverse([...subArray])
    );
    this.polygon = JSON.stringify(reversedPolygon);
  }

  getTableData() {}

  onShowAdvanceSearch() {
    const modalResult = this.dialogService.openModal({
      width: '800px',
      minHeight: '500px',
      component: SendSmartSmsAdvanceSearchlComponent,
    });
    modalResult
      .afterClosed()
      .pipe(
        takeUntil(this.onDestroy$),
        tap(() => {
          AppDomService.removeModalScrollClassFromHtml();
        })
      )
      .subscribe((res) => {
        //remove unckecked polygon from map
        if (TransferDataService.removedListPersonal.length > 0)
          TransferDataService.removedListPersonal.forEach((item) => {
            this.Map().removeSelectedPolygon(item.polygons[0]?.coordinates);
            this.Map().closeShowTitleBtn(
              item.polygons[0]?.coordinates.toString()
            );
          });

        if (TransferDataService.removedListPublic.length > 0)
          TransferDataService.removedListPublic.forEach((item) => {
            this.Map().removeSelectedPolygon(item?.coordinates);
            this.Map().closeShowTitleBtn(item.coordinates.toString());
          });

        res.forEach((place) => {
          let polygonTitle = {
            coordinates: place.polygons[0]?.coordinates,
            title: place.title,
          };

          this.polygonsTitle.push(polygonTitle);

          if (typeof place.polygons[0]?.coordinates == typeof '')
            this.Map().AddDisplayPolygon(
              '',
              [JSON.parse(place.polygons[0]?.coordinates)],
              place.title
            );
          else
            this.Map().AddDisplayPolygon(
              '',
              [place.polygons[0]?.coordinates],
              place.title
            );
        });

        if (res) {
          this.getTableData();
          this.cd.detectChanges();
        }
      });
  }

  convertMapIrPolygonToGmap(polygon: number[][]): Position[][] {
    var result: Position[][] = [[]];
    polygon.forEach((item) => {
      result[0].push([item[1], item[0]]);
    });
    return result;
  }

  ConvertPolygonsTo3plNumberArray(
    input: Array<Position[][]>
  ): number[][][] | null {
    var pls: number[][][] = [];
    input.forEach((polygon) => {
      var item: number[][] = [];
      polygon[0].forEach((it2) => {
        item.push(it2);
      });
      pls.push(item);
    });
    return pls;
  }

  getIsPeriodic() {
    let curlsp = this.form.controls['isPeriodic'].value == true;
    return curlsp;
  }

  changeSmartRequestType(requestType: SmartRequestTypes) {
    this.requiredFields = [];
    this.isShowMap = true;

    this.form.get('campaignId').clearValidators();
    this.form.get('grayListExpireHour').clearValidators();
    this.form.get('clubId').clearValidators();
    this.form.get('operationType').clearValidators();
    this.form.get('cellList').clearValidators();
    this.form.get('cities').clearValidators();
    this.form.get('province').clearValidators();
    this.form.get('provinces').clearValidators();
    this.form.get('targetAirportId').clearValidators();

    this.isPeriodicSmartSend = false;
    this.isShowGrayListExpireHour = false;
    this.isShowCampaigns = false;
    this.isCheckBoxChecked = false;
    this.isShowClub = false;
    this.isShowCities = false;
    this.isShowProvince = false;
    this.isShowProvinces = false;
    this.isShowCellList = false;
    this.isShowTargetAirport = false;

    switch (requestType) {
      ///////////////////////////////////////////// Simple
      case SmartRequestTypes.Simple:
        break;

      ///////////////////////////////////////////// Club
      case SmartRequestTypes.Club:
        this.isShowGrayListExpireHour = true;
        this.isShowCampaigns = true;
        this.isShowClub = true;
        this.isShowCellList = true;
        this.form.get('campaignId').addValidators(Validators.required);
        this.form.get('clubId').addValidators(Validators.required);
        this.form.get('operationType').addValidators(Validators.required);
        this.form.get('grayListExpireHour').addValidators(Validators.required);

        break;
      ///////////////////////////////////////////// Welcome

      case SmartRequestTypes.Welcome:
        this.isShowGrayListExpireHour = true;
        this.isShowCampaigns = true;
        this.form.get('campaignId').addValidators(Validators.required);
        this.form.get('grayListExpireHour').addValidators(Validators.required);

        break;

      ///////////////////////////////////////////// WelcomeWithCells
      case SmartRequestTypes.WelcomeWithCells:
        this.isShowGrayListExpireHour = true;
        this.isShowCampaigns = true;
        this.isShowCellList = true;
        this.form.get('campaignId').addValidators(Validators.required);
        this.form.get('grayListExpireHour').addValidators(Validators.required);
        this.form.get('cellList').addValidators(Validators.required);

        break;
      ///////////////////////////////////////////// WelcomeForCity
      case SmartRequestTypes.WelcomeForCity:
        this.isShowMap = false;
        this.isShowGrayListExpireHour = true;
        this.isShowCampaigns = true;
        this.isShowCities = true;
        this.isShowProvince = true;
        this.form.get('campaignId').addValidators(Validators.required);
        this.form.get('grayListExpireHour').addValidators(Validators.required);
        this.form.get('cities').addValidators(Validators.required);
        this.form.get('province').addValidators(Validators.required);

        break;

      ///////////////////////////////////////////// WelcomeForProvince
      case SmartRequestTypes.WelcomeForProvince:
        this.isShowMap = false;
        this.isShowProvinces = true;
        this.isShowGrayListExpireHour = true;
        this.isShowCampaigns = true;

        this.form.get('campaignId').addValidators(Validators.required);
        this.form.get('grayListExpireHour').addValidators(Validators.required);
        this.form.get('provinces').addValidators(Validators.required);

        break;

      ///////////////////////////////////////////// WelcomeForAirports
      case SmartRequestTypes.WelcomeForAirports:
        this.isShowMap = false;
        this.isShowTargetAirport = true;
        this.isShowGrayListExpireHour = true;
        this.isShowCampaigns = true;
        this.form.get('campaignId').addValidators(Validators.required);
        this.form.get('grayListExpireHour').addValidators(Validators.required);
        this.form.get('targetAirportId').addValidators(Validators.required);

        break;
    }

    this.form.get('campaignId').updateValueAndValidity();
    this.form.get('grayListExpireHour').updateValueAndValidity();
    this.form.get('clubId').updateValueAndValidity();
    this.form.get('operationType').updateValueAndValidity();
    this.form.get('cellList').updateValueAndValidity();
    this.form.get('cities').updateValueAndValidity();
    this.form.get('province').updateValueAndValidity();
    this.form.get('provinces').updateValueAndValidity();
    this.form.get('targetAirportId').updateValueAndValidity();
  }

  isShowSidePanel(event) {
    ConsoleService.info('event', event);
    this.showSidePanel = event;
  }

  getCellsList() {
    try {
      this.unSubs();

      const modalResult = this.dialogService.openModal({
        component: CellsListComponent,
      });

      modalResult
        .afterClosed()
        .pipe(
          takeUntil(this.onDestroy$),
          tap(() => {
            AppDomService.removeModalScrollClassFromHtml();
          })
        )
        .subscribe((res) => {
          if (res) {
            this.cd.detectChanges();
          }
        });
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.smartSms);
    }
  }

  onRemoveDeviceModel(id) {
    this.selectedDeviceModels = this.selectedDeviceModels.filter(
      (item) => item.id !== id
    );
  }
}
